import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Delete.css';
import logo from '../assets/tizm.png';

const Delete = ({ currentLang }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    phoneNumber: '',
    otp: ''
  });

  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(0);

      const content = {
      tr: {
        title: "Sportizm.app Hesap Silme",
        description: "Silme işlemi için telefon numaranızı doğrulayın.",
        button: "Ana Sayfaya Dön",
        deleteButton: "Ürünü Sil",
        labels: {
          phoneNumber: "Telefon Numarası",
          otp: "SMS Doğrulama Kodu"
        },
        placeholders: {
          phoneNumber: "+90 5XX XXX XX XX",
          otp: "6 haneli kod"
        },
        buttons: {
          sendOtp: "SMS Gönder",
          verifyOtp: "Doğrula",
          resendOtp: "Tekrar Gönder"
        },
        messages: {
          otpSent: "SMS gönderildi. Lütfen kodunuzu girin.",
          otpVerified: "Telefon numarası doğrulandı.",
          invalidOtp: "Geçersiz doğrulama kodu.",
          resendTimer: "saniye sonra tekrar gönderebilirsiniz"
        }
      },
      en: {
        title: "Sportizm.app Account Deletion",
        description: "Verify your phone number to proceed with deletion.",
        button: "Back to Home",
        deleteButton: "Delete Account",
        labels: {
          phoneNumber: "Phone Number",
          otp: "SMS Verification Code"
        },
        placeholders: {
          phoneNumber: "+1 XXX XXX XXXX",
          otp: "6-digit code"
        },
        buttons: {
          sendOtp: "Send SMS",
          verifyOtp: "Verify",
          resendOtp: "Resend"
        },
        messages: {
          otpSent: "SMS sent. Please enter your code.",
          otpVerified: "Phone number verified.",
          invalidOtp: "Invalid verification code.",
          resendTimer: "seconds before you can resend"
        }
      }
    };

  const t = content[currentLang];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'phoneNumber') {
      setFormData(prev => ({
        ...prev,
        [name]: formatPhoneNumber(value)
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle deletion logic here
    console.log('Delete request:', formData);
  };

  const handleSendOtp = async () => {
    if (!formData.phoneNumber) return;
    
    setIsLoading(true);
    try {
      // Simulate SMS sending - replace with actual SMS service
      await new Promise(resolve => setTimeout(resolve, 1000));
      setOtpSent(true);
      setTimer(60); // 60 second timer
      console.log('OTP sent to:', formData.phoneNumber);
    } catch (error) {
      console.error('Error sending OTP:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!formData.otp) return;
    
    setIsLoading(true);
    try {
      // Simulate OTP verification - replace with actual verification
      await new Promise(resolve => setTimeout(resolve, 500));
      // For demo purposes, accept "123456" as valid OTP
      if (formData.otp === '123456') {
        setOtpVerified(true);
        console.log('OTP verified successfully');
      } else {
        alert(t.messages.invalidOtp);
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatPhoneNumber = (value) => {
    // Remove all non-digits
    const cleaned = value.replace(/\D/g, '');
    
    // Format for Turkish numbers (+90 5XX XXX XX XX)
    if (currentLang === 'tr') {
      if (cleaned.length <= 10) {
        return cleaned.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '0$1 $2 $3 $4');
      }
      return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 $2 $3 $4 $5');
    }
    
    // Format for other countries (basic format)
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
  };

  const isFormValid = formData.phoneNumber && otpVerified;

  // Timer effect
  React.useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer(timer - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  return (
    <div className="delete-container">
      <div className="delete-content">
        <div className="delete-logo">
          <img src={logo} alt="Sportizm" />
        </div>
        <h1>{t.title}</h1>
        <p>{t.description}</p>
        
        <form onSubmit={handleSubmit} className="delete-form">
          <div className="form-group">
            <label htmlFor="phoneNumber">{t.labels.phoneNumber}</label>
            <div className="phone-input-group">
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                placeholder={t.placeholders.phoneNumber}
                required
              />
              <button
                type="button"
                className={`otp-button ${!formData.phoneNumber || otpSent ? 'disabled' : ''}`}
                onClick={handleSendOtp}
                disabled={!formData.phoneNumber || otpSent || isLoading}
              >
                {isLoading ? '...' : (timer > 0 ? `${timer}s` : t.buttons.sendOtp)}
              </button>
            </div>
          </div>

          <div className="button-group">
            <button 
              type="submit"
              className={`delete-button ${isFormValid ? 'enabled' : 'disabled'}`}
              disabled={!isFormValid}
            >
              {t.deleteButton}
            </button>
            <button 
              type="button"
              className="back-home-button"
              onClick={() => navigate('/')}
            >
              {t.button}
            </button>
          </div>
        </form>

        {/* OTP Popup Modal */}
        {otpSent && (
          <div className="otp-popup-overlay" onClick={() => setOtpSent(false)}>
            <div className="otp-popup" onClick={(e) => e.stopPropagation()}>
              <div className="otp-popup-header">
                <h3>{t.labels.otp}</h3>
                <button 
                  className="close-button"
                  onClick={() => setOtpSent(false)}
                >
                  ×
                </button>
              </div>
              
              <div className="otp-popup-content">
                <p className="otp-message">{t.messages.otpSent}</p>
                
                <div className="otp-input-group">
                  <input
                    type="text"
                    id="otp"
                    name="otp"
                    value={formData.otp}
                    onChange={handleInputChange}
                    placeholder={t.placeholders.otp}
                    maxLength="6"
                    required
                  />
                  <button
                    type="button"
                    className={`verify-button ${!formData.otp || otpVerified ? 'disabled' : ''}`}
                    onClick={handleVerifyOtp}
                    disabled={!formData.otp || otpVerified || isLoading}
                  >
                    {isLoading ? '...' : (otpVerified ? '✓' : t.buttons.verifyOtp)}
                  </button>
                </div>

                {otpVerified && (
                  <div className="otp-success">
                    <p>{t.messages.otpVerified}</p>
                  </div>
                )}

                {timer > 0 && !otpVerified && (
                  <p className="timer-text">
                    {timer} {t.messages.resendTimer}
                  </p>
                )}

                {timer === 0 && !otpVerified && (
                  <button
                    type="button"
                    className="resend-button"
                    onClick={handleSendOtp}
                    disabled={isLoading}
                  >
                    {t.buttons.resendOtp}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Delete; 